import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import { useRef } from 'react';

type Searchable = string | number | null | undefined;

function normalizarValor(valor: unknown): string {
  if (valor == null) return '';

  if (valor instanceof Date) {
    return Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    }).format(valor);
  }

  if (typeof valor === 'string') {
    const parsed = new Date(valor);

    if (!Number.isNaN(parsed.getTime())) {
      return Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(parsed);
    }

    return valor.toLowerCase();
  }

  return String(valor).toLowerCase();
}

function filtrarLista<T>(
  lista: T[],
  search: string,
  camposBuscar: Array<(item: T) => Searchable>,
): T[] {
  const termo = search.toLowerCase().trim();
  if (!termo) return lista;

  return lista.filter(item =>
    camposBuscar.some(fn => {
      return normalizarValor(fn(item)).includes(termo);
    }),
  );
}

interface Entrada<T> {
  lista: T[];
  camposBuscar: Array<(item: T) => Searchable>;
  setState: React.Dispatch<React.SetStateAction<T[]>>;
  largura?: number;
  exibirCampo?: boolean;
}

export default function CampoBuscaFiltrarLista<T>({
  lista,
  camposBuscar,
  setState,
  largura = 40,
  exibirCampo = true,
}: Entrada<T>): JSX.Element {
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

  async function filtroTabela(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const search = event.target.value;
    const filtrados = filtrarLista(lista, search, camposBuscar);

    setState(filtrados);
  }

  return (
    <TextField
      className="float-right"
      id="outlined-basic"
      label="Buscar"
      variant="outlined"
      size="small"
      type="text"
      hidden={!exibirCampo}
      inputRef={inputRef}
      onChange={filtroTabela}
      style={{
        width: `${largura}%`,
        backgroundColor: '#fff',
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            position="end"
            hidden={(inputRef.current?.value ?? '') === ''}
          >
            <IconButton
              size="small"
              onClick={() => {
                const input = inputRef.current;
                if (!input) return;

                input.value = '';
                setState([]);

                const event = new Event('input', { bubbles: true });
                input.dispatchEvent(event);
              }}
            >
              <CloseOutlined fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
